var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"q-summit-step-background-bottom",class:{ 'q-summit-step-background-bottom--mobile': _vm.$vuetify.breakpoint.smAndDown }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }